export default function isDigitalExhibitTemplate(seedNode?: SeedNode): boolean {
  if (!seedNode) return false;

  return Boolean(
    seedNode && (
      seedNode.template?.templateName === 'Digital Exhibit' ||
      seedNode.__typename === 'DigitalExhibit'
    )
  );
}